<template>
    <el-row :gutter="10">
        <el-col :span="getSpan(item)" class="listview-wrapper__search_form-item" v-for="(item) in searchItems" :key="item.key">
            <div class="listview-wrapper__search_condition-title" :style="labelStyle">
                <span>{{ item.label }}{{ sperator }}</span>
            </div>
            <div class="listview-wrapper__search_conditon-operate">
                <!-- input 输入类型 -->
                <el-input
                    v-if="item.type === 'input'"
                    :ref="item.key"
                    v-model="valueData[item.key]"
                    type="text"
                    :maxlength="item.maxlength || defaultInput"
                    :minlength="item.minlength"
                    :disabled="item.disabled"
                    :show-word-limit="item.showWordLimit"
                    :placeholder="item.placeholder || '请输入'"
                    :trigger-on-focus="false"
                    :clearable="!item.notClear"
                    @keyup.enter.native="queryList"
                    @input="onItemChange($event, item)"
                />
                <!-- 普通下拉框 -->
                <el-select
                    v-if="item.type === 'select'"
                    :class="{'only-one-select': item.multiple && valueData[item.key] && valueData[item.key].length > 1}"
                    :ref="item.key"
                    v-model="valueData[item.key]"
                    collapse-tags
                    :multiple="item.multiple"
                    :remote-method="item.remoteMethod ? (query) => {item.remoteMethod && item.remoteMethod(query, item)} : null"
                    :remote="item.remote"
                    :loading="item.loading"
                    :disabled="item.disabled"
                    :filterable="item.filterable"
                    :placeholder="item.placeholder || '请选择'"
                    :clearable="!item.notClear"
                    @change="onItemChange($event, item)"
                >  
                    <el-option :class="item.className || ''" v-for="itemInner in (item.options || [])" :key="itemInner.value" :label="itemInner.label" :value="itemInner.value">
                        <div v-if="item.diyOptionsFunc" class="tq-diy-select" v-html="item.diyOptionsFunc(itemInner)"></div>
                        <span v-else>{{ itemInner.label }}</span>
                    </el-option>
                </el-select>
                <!-- 日期选择器 -->
                <el-date-picker
                    v-if="item.type === 'datePicker'"
                    style="width: 100%;box-sizing: border-box;"
                    :ref="item.key"
                    v-model="valueData[item.key]"
                    :placeholder="item.placeholder"
                    :type="item.compType"
                    :readonly="item.readonly"
                    :disabled="item.disabled"
                    :editable="item.editable"
                    :default-value="item.defaultValue"
                    :default-time="item.defaultTime"
                    :value-format="item.valueFormat"
                    :append-to-body="item.appendToBody"
                    :clearable="item.clearable"
                    :start-placeholder="item.startPlaceholder"
                    :end-placeholder="item.endPlaceholder"
                    :picker-options="item.pickerOptions"
                    :format="item.format"
                    :align="item.align"
                    :popper-class="item.popperClass"
                    :range-separator="item.rangeSeparator"
                    :disabled-date="item.disabledDate"
                    @change="onItemChange($event, item)"
                    @calendar-change="calendarChange($event, item)"
                >
                </el-date-picker>
                <!-- 级联选择器 -->
                <el-cascader v-if="item.type === 'cascader'"
                    :ref="item.key"
                    v-model="valueData[item.key]"
                    :placeholder="item.placeholder || '请选择'"
                    :options="item.options"
                    :props="item.props"
                    :disabled="item.disabled"
                    :clearable="(typeof item.clearable === 'boolean' ? item.clearable : true)"
                    :show-all-levels="item.showAllLevels"
                    :collapse-tags="item.collapseTags"
                    :separator="item.separator"
                    :filterable="item.filterable"
                    :filter-method="item.filterMethod"
                    :debounce="item.debounce"
                    :before-filter="item.beforeFilter"
                    :popper-class="item.popperClass"
                    @change="onItemChange($event, item)"
                ></el-cascader>
                <!-- 部门选择器 -->
                <!-- <template v-if="item.type === 'department'">
                    <tq-input-department ref="TqInputDepartment" :item="item" @selectedDepartment="selectedDepartment"></tq-input-department>
                </template> -->
                <!-- 人员选择器 -->
                <!-- <template v-if="item.type === 'person'">
                    <tq-input-person ref="TqInputPerson" :item="item" @selectedPerson="selectedPerson"></tq-input-person>
                </template> -->
                <!-- 自定义类型 -->
                <template v-if="item.type === 'custom'">
                    <slot :name="item.key" />
                </template>
            </div>
        </el-col>
        <el-col :span="6" class="listview-wrapper__search_form-item" key="searchBtn" v-if="isOneline">
            <div class="oneline-search-btns">
                <el-button type="primary" plain @click="resetList">重置</el-button>
                <el-button type="primary" @click="queryFirstPage">查询</el-button>
            </div>
        </el-col>
    </el-row>
</template>

<script lang="ts">
export default {
    data() {
        return {
        }
    },
    props: {
		searchItems: {
			type: Array,
			default() {
				return []
			}
		},
		valueData: {
			type: Object,
			default() {
				return {}
			}
		},
        isOneline: {
            type: Boolean,
            default: false
        },
        defaultInput: {
            type: Number,
            default: 100000,
        },
        labelWidth: {
            type: String,
            default: "",
        },
		sperator: {
			type: String,
			default: '：'
		}
	},
    computed: {
        labelStyle() {
            if (this.labelWidth) {
                return {
                    'width': this.labelWidth
                }
            }
            return {}
        }
    },
    methods: {
        resetList() {
            this.$emit("resetList")
        },
        queryFirstPage() {
            this.$emit("queryFirstPage")
        },
        clearAllSelectorLabel() {
            const alldDepartmentSelectors = this.$refs.TqInputDepartment
            if (alldDepartmentSelectors && alldDepartmentSelectors.length > 0) {
                for (let index = 0; index < alldDepartmentSelectors.length; index++) {
                    const element = alldDepartmentSelectors[index];
                    if (element.clearSelectorLabel) {
                        element.clearSelectorLabel()
                    }
                }
            }

            const alldPersonSelectors = this.$refs.TqInputPerson
            if (alldPersonSelectors && alldPersonSelectors.length > 0) {
                for (let index = 0; index < alldPersonSelectors.length; index++) {
                    const element = alldPersonSelectors[index];
                    if (element.clearSelectorLabel) {
                        element.clearSelectorLabel()
                    }
                }
            }
        },
		onItemChange(event, item) {
			item.onChanged && item.onChanged(event)
		},
        calendarChange(event, item) {
			item.calendarChange && item.calendarChange(event)
		},
        queryList() {
            this.$emit('queryEnterList')
        },
        getSpan(item) {
            if (item.span) {
                return item.span
            }
            return (item.type === 'datePicker' && (item.compType === 'daterange' || item.compType === 'datetimerange')) ? 12 : 6
        },
        selectedPerson(item, value) {
            this.valueData[item.key] = value;
        },
        selectedDepartment(item, value) {
            this.valueData[item.key] = value;
        },
	}
}
</script>
